var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1216_3812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.417 25.4997C8.85158 25.4997 7.59783 26.7676 7.59783 28.333C7.59783 29.8984 8.85158 31.1663 10.417 31.1663C11.9824 31.1663 13.2503 29.8984 13.2503 28.333C13.2503 26.7676 11.9824 25.4997 10.417 25.4997ZM1.91699 2.83301V5.66634H4.75033L9.84324 16.4118L7.93074 19.8826C7.71116 20.2934 7.58366 20.7538 7.58366 21.2497C7.58366 22.8151 8.85158 24.083 10.417 24.083H27.417V21.2497H11.0191C10.8207 21.2497 10.6649 21.0938 10.6649 20.8955C10.6649 20.8318 10.6791 20.7751 10.7074 20.7255L11.9753 18.4163H22.5295C23.592 18.4163 24.5199 17.8284 25.0087 16.9572L30.0732 7.76301C30.1866 7.56467 30.2503 7.33092 30.2503 7.08301C30.2503 6.70728 30.1011 6.34695 29.8354 6.08127C29.5697 5.8156 29.2094 5.66634 28.8337 5.66634H7.88824L6.54241 2.83301H1.91699ZM24.5837 25.4997C23.0182 25.4997 21.7645 26.7676 21.7645 28.333C21.7645 29.8984 23.0182 31.1663 24.5837 31.1663C26.1491 31.1663 27.417 29.8984 27.417 28.333C27.417 26.7676 26.1491 25.4997 24.5837 25.4997Z",
    fill: "#FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1216_3812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/Cart.30d062d6e7616052ef4bbeebeb149de2.svg";
export { ForwardRef as ReactComponent };